import { bulk } from './update';
import addError from '../../../utils/error.jsx';

export function request(sport, list, displayFields) {
    return {
        type: 'COMPETITIONS_LIST_MOVE_REQUEST',        
        sport,
        list,
        displayFields
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'COMPETITIONS_LIST_MOVE_ERROR',
        errors
    };
}

export function finish(competitions) {
    return (dispatch) => {
        dispatch(bulk(competitions));

        dispatch({
            type: 'COMPETITIONS_LIST_MOVE_FINISH',
            competitions
        });
    };
}

export function clear() {
    return {
        type: 'COMPETITIONS_LIST_MOVE_CLEAR'
    };
}
